import { createFileRoute } from "@tanstack/react-router";
import { TinyIntegrationPanel } from "@/components/admin/tiny-integration-panel";
import { adminOrdersQuery } from "@/lib/admin/admin.functions";
import { adminTinyConnectionStatusQuery } from "@/lib/admin/erp.functions";

export const Route = createFileRoute("/admin/integracao-tiny")({
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(adminOrdersQuery()),
      context.queryClient.ensureQueryData(adminTinyConnectionStatusQuery()),
    ]);
  },
  component: IntegracaoTinyPage,
});

function IntegracaoTinyPage() {
  return (
    <div>
      <h1 className="mb-2 font-display text-2xl font-bold text-eg-dark">Integração Tiny</h1>
      <p className="mb-6 text-sm text-muted-foreground">
        Status da conexão com o ERP Tiny/Olist, sincronização manual de produtos e estoque, e
        reconciliação de pedidos com falha de envio.
      </p>
      <TinyIntegrationPanel />
    </div>
  );
}
